import { render } from "./SearchProject.vue?vue&type=template&id=42b1db47&scoped=true"
import script from "./SearchProject.vue?vue&type=script&lang=js"
export * from "./SearchProject.vue?vue&type=script&lang=js"

import "./SearchProject.vue?vue&type=style&index=0&id=42b1db47&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42b1db47"]])

export default __exports__